export const navAndReload = (path: string) => {
  window.location.href = path;
};
